export const getFormattedType = type => {
  switch (type) {
    case 'Videos':
    case 'video':
      return 'video';
    case 'Apps':
    case 'application':
      return 'app';
    case 'Podcasts':
    case 'podcast':
    case 'episode':
    case 'Episode':
      return 'podcast';
    case 'People':
    case 'person':
      return 'person';
    case 'Books':
    case 'book':
      return 'book';
    case 'Articles':
    case 'activity':
    case 'News':
      return 'article';
    case 'Organizations':
    case 'organization':
      return 'organization';
    case 'Events':
    case 'events':
      return 'event';
    case 'Online Programs':
    case 'onlineProgram':
    case 'onlineprogram':
      return 'program';
    case 'topics':
      return 'topic';
    case 'assessments':
      return 'assessment';
    case 'landing':
      return 'landing';
    case 'source':
      return 'source';
    default:
      return null;
  }
};

export const getReverseType = type => {
  switch (type) {
    case 'activity':
      return 'Reads';
    case 'application':
      return 'Apps';
    case 'assessments':
      return 'Assessments';
    case 'book':
      return 'Books';
    case 'onlineProgram':
      return 'Online Programs';
    case 'organization':
      return 'Organizations';
    case 'person':
      return 'People';
    case 'podcast':
      return 'Podcasts';
    case 'source':
      return 'FAQ';
    case 'topics':
      return 'Topics';
    case 'video':
      return 'Videos';
    default:
      return null;
  }
};
